import { getLocationSettings } from "./location";

export const isCustomComponentLink = (rawComponent: string): boolean => {
    const locationSettings = getLocationSettings();
    const url = `${locationSettings.aiCustomComponentDomain}/share`;
    return rawComponent.startsWith(url);
};
